<template>
  <div>

    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="" prop="companyCode">
        <el-input size="mini" clearable v-model="formInline.t.interfaceName" :placeholder="$t('qing-shu-ru-jie-kou-ming-cheng')">
        </el-input>
      </el-form-item>

      <el-form-item prop="startTime">
        <el-date-picker type="datetime" size="mini"
                        v-model="formInline.t.startTime"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('kai-shi-ri-qi')" style="width: 175px"></el-date-picker>
        <span>{{ $t('deviceControl.to') }}</span>
        <el-date-picker type="datetime" size="mini"
                        v-model="formInline.t.endTime"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('jie-shu-ri-qi')" style="width: 175px"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">{{ $t('deviceControl.empty') }}</el-button>
        <el-button size="mini" type="primary" :loading='loading' icon="el-icon-search" @click="search">{{ $t('deviceControl.search') }}</el-button>

        <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd()"
                   v-if="checkPermission(['bee:ict:cecInterfaceName:insert'])">{{ $t('deviceControl.Add') }}
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
              @selection-change="selectChange"
              :data="userData"
              highlight-current-row
              v-loading="loading"
              border
              :element-loading-text="$t('paramMonitor.Loading')"
              style="width: 100%;">


      <af-table-column prop="interfaceName" :label="$t('jie-kou-ming-cheng')">
      </af-table-column>
      <af-table-column prop="interfaceExplain" :label="$t('jie-kou-miao-shu')">
      </af-table-column>
      <af-table-column prop="createTime" :label="$t('chuang-jian-shi-jian')">
      </af-table-column>

      <af-table-column :label="$t('deviceControl.operation')">
        <template slot-scope="scope">

          <template v-if="checkPermission(['bee:ict:cecInterfaceName:update'])">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">{{ $t('alaramMonitor.edit') }}</el-button>
          </template>

          <template v-if="checkPermission(['bee:ict:cecInterfaceName:deleteInterfaceByID'])">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t('deviceControl.delete') }}</el-button>
          </template>
        </template>
      </af-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination :child-msg="pageParam" @callFather="callFather"></Pagination>

    <!-- 添加界面 -->
    <AddPage
      :form-visible="addFormVisible"
      :searchData="searchData"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></AddPage>

    <!--修改-->
    <UpdatePage
      :form-visible="updateFormVisible"
      :searchData="searchData"
      :selectRowData="selectRowData"
      @closeDialog="closeDialog"
      @afterUpdate="afterUpdate"
    ></UpdatePage>

  </div>
</template>

<script>
    import Pagination from '@/components/Pagination.vue'
    import AddPage from '@/module/interactionCenter/page/cec/interface/add.vue'
    import UpdatePage from '@/module/interactionCenter/page/cec/interface/update.vue'
    import api from '@/module/interactionCenter/api/interface.js'

    export default {
        data() {
            return {
                addFormVisible: false,
                updateFormVisible: false,
                offVisible: false,
                onVisible: true,
                loading: false, // 是显示加载
                // 选择数据
                selectData: [],
                // 请求数据参数
                formInline: {
                    t: {
                        interfaceName: '',
                         startTime:'',
                         endTime:''
                    }
                },
                // 分页参数
                pageParam: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
                // 列表数据
                userData: [],
                // 表单查询条件
                searchData: {
                },

                // 选中列数据
                selectRowData: {},
              pickerOptions: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
                shortcuts: [{
                  text: this.$t('jin-tian'),
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  }
                }, {
                  text: this.$t('zuo-tian'),
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                  }
                }, {
                  text: this.$t('yi-zhou-qian'),
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                  }
                }]
              }
            }
        },
        // 注册组件
        components: {
            AddPage,
            Pagination,
            UpdatePage
        },
        created() {
            this.search()
        },
        filters: {
        },
        watch: {},
        methods: {
            handleDelete(index, row) {
                if (!row) {
                    return
                }
                this.$confirm(this.$t('ci-cao-zuo-jiang-yong-jiu-shan-chu-gai-ji-lu-shi-fou-ji-xu'), this.$t('deviceControl.prompt'), {
                    confirmButtonText: this.$t('deviceControl.confirm'),
                    cancelButtonText: this.$t('alaramMonitor.cancel'),
                    type: 'warning'
                }).then(() => {
                    api.deleteInterfaceById(row.id).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                type: 'success',
                                message: this.$t('shan-chu-cheng-gong-0')
                            });
                            this.search()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('yi-qu-xiao-shan-chu')
                    })
                })
            },
            // 获取数据方法
            getData(parameter) {
                this.loading = true
                api.getPage(JSON.stringify(parameter)).then((res) => {
                    this.userData = res.data.list
                    // 分页赋值
                    this.pageParam.currentPage = res.data.pageNum
                    this.pageParam.total = res.data.total

                    // 加载结束
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                })
            }
            ,
            // 分页插件事件
            callFather() {
                let data = {
                    currentPage: this.pageParam.currentPage,
                    pageSize: this.pageParam.pageSize,
                    t: this.formInline.t
                }
                this.getData(data)
            }
            ,
            resetSearchForm() {
                this.formInline.t = {}
                this.search()
            },
            // 搜索事件
            search() {
                this.getData(this.formInline)
            }
            ,
            // 显示编辑界面
            handleEdit: function (index, row) {
                if (row !== undefined) {
                    this.selectRowData = row
                    this.updateFormVisible = true
                }
            }
            ,
            // 添加
            handleAdd: function () {
                this.addFormVisible = true
            }
            ,
            // 选择复选框事件
            selectChange(val) {
                this.selectData = val
            }
            ,
            // 更新成功之后的操作
            afterUpdate() {
                this.updateFormVisible = false
                this.callFather()
            }
            ,
            // 添加成功后操作
            afterAdd() {
                this.addFormVisible = false
                this.search()
            }
            ,
            // 关闭弹框
            closeDialog(type) {
                console.log('type:' + type)
                if (type === 'update') {
                    this.updateFormVisible = false
                } else if (type === 'add') {
                    this.addFormVisible = false
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/interface/list.vue